module.exports = __webpack_public_path__ + "img/Widget_card_headpics_SB_step.41b1777c.jpg";